import { CostAdjustmentStateEnums } from "src/app/enum/cost-adjustment-enums";

export class CostAdjustmentModel {
    costAdjustmentId: number = 0;
    inventoryId: number = 0;
    branchId: number = 0;
    consecutive: number = 0;
    dateCostAdjustment: Date = new Date();
    inventoryPeriodId: number = 0;
    costAdjustmentState: number = CostAdjustmentStateEnums.open;
    inventoryEntryId: number = 0;
    providerId: number = 0;
    provider: any | null = null;
    remission: string | null = null;
    invoice: string | null = null;
    observation: string | null = null;
    totalValue: number = 0;
    createDate: Date = new Date();
    userNameCreate: string = '';
    updateDate: Date | null = null;
    userNameUpdate: string | null = null;
}